var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cropp-image",style:({ transform: 'scale(' + _vm.imgConfig.scale + ')' })},[_c('div',{style:(_vm.imgConfig.mainStyle)},[(_vm.objTest(_vm.imgConfig))?_c('img',{staticClass:"cropped-image",style:([
        {
          'object-position':
            (_vm.imgConfig.cropp.pos.x || 0) +
            (_vm.imgConfig.cropp.pos.unit + ' ' || '% ') +
            (_vm.imgConfig.cropp.pos.y || 0) +
            (_vm.imgConfig.cropp.pos.unit || '%'),
          width: _vm.imgConfig.cropp.width + 'px',
          height: _vm.imgConfig.cropp.height + 'px',
          transform: 'scale(' + _vm.scale + ')',
        },
        _vm.imgConfig.zoom ? {} : { cursor: 'auto' },
        _vm.imgConfig.cssStyle ]),attrs:{"id":"img-answer","src":_vm.giveMeImagePlease(_vm.imgConfig.src)},on:{"mousemove":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onMouseMove($event)},"mouseenter":function($event){_vm.zoomShow = true},"mouseleave":function($event){_vm.zoomShow = false},"load":function($event){return _vm.loadImg($event)}}}):_vm._e()]),(_vm.imgConfig.zoom && _vm.tmpZoom)?_c('div',{staticStyle:{"position":"fixed","background-repeat":"no-repeat"},style:([
      {
        width: _vm.size * 2 + 'px',
        height: _vm.size * 2 + 'px',
        top: (1080 - _vm.size * 2) / 2 + 'px',
        transform: 'scale(' + _vm.zoom + ')',
        right: (1920 / 2 - _vm.size * 2) / 2 + 'px',
        'transform-origin': 'center center',
      } ]),on:{"mouseenter":function($event){_vm.changePosition = !_vm.changePosition}}},[_c('img',{staticClass:"zoomed-image",style:([
        {
          'object-position': _vm.left + '% ' + _vm.top + '%',
          width: _vm.size * 2 + 'px',
          height: _vm.size * 2 + 'px',
        } ]),attrs:{"src":_vm.giveMeImagePlease(_vm.imgConfig.src)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }